module.exports = __webpack_public_path__ + "static/money-44af8016a1aa0130409ea868e034791c.jpeg";